<p
  class="mat-dialog-title--fullWidth u-borderBottom-grey100"
  mat-dialog-title
  i18n="@@global.addToCalendar"
>
  Add to calendar
</p>
<mat-dialog-content>
  <div
    class="u-padding-24 u-borderRadius--4px u-border-grey100 u-marginBottom-16"
  >
    <p class="text-subtitle-1" [ngStyle]="{ marginBottom: '4px' }">
      <b>{{ data.calendarEvent.title }}</b>
    </p>
    <p class="text-caption color-grey-300">
      {{ calculatedDate.startDate | date: 'mediumDate' }}
      {{ calculatedDate.startDate | date: 'shortTime' }} -
      {{ calculatedDate.endDate | date: 'shortTime' }}
    </p>
  </div>
  <app-add-to-calendar-chips
    class="u-display-block"
    [calendarEvent]="data.calendarEvent"
    [supportedProviders]="data.supportedProviders"
  ></app-add-to-calendar-chips>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end center"
  [ngStyle]="{ 'margin-left': '-24px', 'margin-right': '-24px' }"
  class="u-borderTop-grey100"
>
  <div class="u-padding-0-8">
    <button
      mat-button
      color="primary"
      [mat-dialog-close]="true"
      i18n="@@global.done"
    >
      Done
    </button>
  </div>
</mat-dialog-actions>
